export default function openPDFInViewer() {
    console.log('=== openPDFInViewer appelé ===');
    
    // Utiliser le fichier PDF local - URL absolue pour éviter les problèmes
    const pdfUrl = '/file/user-guide.pdf';
    
    console.log('URL du PDF:', pdfUrl);
    console.log('process.env.PUBLIC_URL:', process.env.PUBLIC_URL);
    console.log('Fonction globale disponible:', !!(window as any).openPDFViewer);
    console.log('Type de la fonction globale:', typeof (window as any).openPDFViewer);
    
    // Attendre un peu pour s'assurer que l'app est montée
    setTimeout(() => {
        console.log('Tentative d\'ouverture du PDF après timeout...');
        
        // Utiliser la fonction globale exposée par App.tsx
        if ((window as any).openPDFViewer) {
            console.log('Appel de la fonction globale openPDFViewer avec:', pdfUrl);
            try {
                (window as any).openPDFViewer(pdfUrl);
                console.log('Fonction openPDFViewer appelée avec succès');
            } catch (error) {
                console.error('Erreur lors de l\'appel de openPDFViewer:', error);
            }
        } else {
            console.error('Fonction globale openPDFViewer non disponible !');
            console.log('window.openPDFViewer:', (window as any).openPDFViewer);
            console.log('Toutes les propriétés window commençant par "open":', Object.keys(window).filter(k => k.startsWith('open')));
            
            // Fallback vers téléchargement si le viewer n'est pas disponible
            console.warn('PDFViewer not available, falling back to download');
            const a = document.createElement("a");
            a.href = pdfUrl;
            a.target = "_blank";
            a.download = 'User-Guide.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }, 100);
}
